import { DOTS_DEFAULTS } from "@/lib/sectionVariants";

const dotBox = (shape, size, isActive, grow) => {
  const s = Number(size) || 8;
  if (shape === "line") return { width: s * 3 * (isActive && grow ? 1.6 : 1), height: Math.max(2, Math.round(s / 3)), borderRadius: 999 };
  if (shape === "pill") return { width: s * 2 * (isActive && grow ? 1.6 : 1), height: s, borderRadius: 999 };
  const width = isActive && grow ? s * 2.4 : s;
  return { width, height: s, borderRadius: shape === "square" ? 2 : 999 };
};

export const BannerDots = ({ count, active, onSelect, config, testId = "banner-dots" }) => {
  const cfg = { ...DOTS_DEFAULTS, ...(config || {}) };
  const activeColor = cfg.active_color || "hsl(var(--primary))";
  return (
    <div className="flex items-center justify-center" style={{ gap: Number(cfg.spacing) || 6 }} data-testid={testId}>
      {Array.from({ length: count }).map((_, i) => {
        const isActive = i === active;
        const color = isActive ? activeColor : cfg.color;
        const outline = cfg.style === "outline";
        return (
          <button
            key={i}
            type="button"
            aria-label={`Ir para a página ${i + 1}`}
            onClick={() => onSelect && onSelect(i)}
            data-testid={testId === "banner-dots" ? `banner-dot-${i}` : `${testId}-${i}`}
            data-active={isActive ? "true" : "false"}
            style={{
              ...dotBox(cfg.shape, cfg.size, isActive, cfg.active_grow),
              background: outline && !isActive ? "transparent" : color,
              border: outline ? `2px solid ${color}` : "none",
              transition: "width 250ms ease, background-color 250ms ease",
            }}
          />
        );
      })}
    </div>
  );
};

export default BannerDots;
